import type { RouteObject } from "react-router-dom";

import { PerimeterLayout } from "@components/PerimeterLayout/PerimeterLayout";
import { PerimeterContracts } from "@pages/PerimeterContracts/PerimeterContracts";
import { PerimeterCustomers } from "@pages/PerimeterCustomers/PerimeterCustomers";
import { PerimeterSite } from "@pages/PerimeterSite/PerimeterSite";
import { PerimeterSites } from "@pages/PerimeterSites/PerimeterSites";

import { ROUTES } from "./router.constants";

export const perimeterRoutes: RouteObject[] = [
  {
    path: ROUTES.PERIMETER_CUSTOMERS,
    element: (
      <PerimeterLayout>
        <PerimeterCustomers />
      </PerimeterLayout>
    ),
  },
  {
    path: ROUTES.PERIMETER_CONTRACTS,
    element: (
      <PerimeterLayout>
        <PerimeterContracts />
      </PerimeterLayout>
    ),
  },
  {
    path: ROUTES.PERIMETER_CONTRACTS_BY_CUSTOMER,
    element: (
      <PerimeterLayout>
        <PerimeterContracts />
      </PerimeterLayout>
    ),
  },
  {
    path: ROUTES.PERIMETER_SITES,
    element: (
      <PerimeterLayout>
        <PerimeterSites />
      </PerimeterLayout>
    ),
  },
  {
    path: ROUTES.PERIMETER_SITES_BY_CONTRACT,
    element: (
      <PerimeterLayout>
        <PerimeterSites />
      </PerimeterLayout>
    ),
  },
  {
    path: ROUTES.PERIMETER_SITE,
    element: (
      <PerimeterLayout>
        <PerimeterSite />
      </PerimeterLayout>
    ),
  },
];
